import { FormGroup, FormControl, Validators } from "@angular/forms" 

export const noteForm = () => new FormGroup({
  noteID: new FormControl(null),
  category: new FormControl(null, Validators.required),
  subCategory: new FormControl(null, Validators.required),
  entityType: new FormControl(null, Validators.required),
  entityID: new FormControl(null, Validators.required),
  content: new FormControl(null, Validators.required),
});
